export const filterMessageError = (errors) => {
  const messagesWithIndex = errors.reduce((accumulator, message, index) => {
    if (accumulator[message]) {
      accumulator[message].push(index);
    } else {
      accumulator[message] = [index];
    }
    return accumulator;
  }, {});

  const uniqueMessages = Object.keys(messagesWithIndex);

  const messagesWithGreeting = uniqueMessages.map((message) => {
    const indices = messagesWithIndex[message];
    if (indices.length > 1) {
      const lineInWorksheet = indices.map((i) => i + 2);
      return `${message} [linhas ${lineInWorksheet.join(', ')}]`;
    }
    return `${message} [linha ${Number(indices) + 2}]`;
  });

  return messagesWithGreeting;
};
